module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sl":{"installApp":"Na voljo je posodobitev.","install":"Posodobi","noInstall":"Ne, hvala"},"en":{"installApp":"New content is available.","install":"Refresh","noInstall":"No, thanks"},"de":{"installApp":"Neue Inhalte sind verfügbar.","install":"Aktualisieren","noInstall":"Nein, Danke"}}')
  delete Component.options._Ctor
}
